/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import WidgetDialog from '../components/dialogs';

import TitleHeader from '../components/titleHeader';
import ContentContainer from '../components/contentContainer';
import PrimaryButton from '../components/primaryButton';

import { useStyles, buttonCSSFallback } from './styles';

import useSchedules from '../../store/models/schedules/useSchedules';
import Select from '../components/select';
import useWidgetTheme from '../../commons/widgetTheme';
import TranslationIds from '../../commons/translationIds';
import useTranslator from '../../commons/translations';
import ScheduleList from './scheduleList';
import useUIStates from '../../store/models/uistates/useUIStates';

import { useCommonUIStyles } from '../../commons/uiStyles';
import { useAppStore } from '../../store/models/app';

import usePageTransitions from '../../store/models/animations/usePageTransitions';
import transitions, 
{
    TransitionDirection,
    TransitionViewNames,
    TransitionViewRenderers,
} from '../../store/models/animations/actions/transitions';
import useKickstarted from '../../commons/hooks/useKickstarted';
import useElementHeights from '../../commons/hooks/useElementsHeight';

function Schedules (props) {
    const {
        viewAnimation = false,
        initStyles = {},
    } = props;

    const {
        schedules,
        categories,
        byCategories,
        categoryValue,
        selectSchedulesByCategory,
    } = useSchedules();

    const {
        elementsHeight,
    } = useElementHeights({
        selectors: [
            '.schedule-header',
            '.action-bar',
        ],
    });
    const  {
        translate,
        translateWithValues,
    } = useTranslator();

    const {
        selectedSchedules,
        captureFields,
        dispatchError,
    } = useUIStates();

    useKickstarted({
        onKickstarted: () => {
            if (schedules.length <= 0) {
                dispatchError({
                    title: translate(TranslationIds.COMPONENT_WHOA),
                    message: translate(TranslationIds.SUCCESS_PAGE_COULD_NOT_FIND),
                })
            }
        }
    });

    const {
        widget,
        widgetTheme,
        hasCustomCSS,
    } = useWidgetTheme({
        selector: '.ecal-primary-button',
        styleFallback: buttonCSSFallback,
    });

    const {
        setTransitionsWithTarget,
        setViewRenderer,
    } = usePageTransitions({
        elementName: getName(),
        viewAnimation,
    });

    const {
        commonUIStyles,
    } = useCommonUIStyles({
        widget,
        widgetTheme,
    });

    const classes = useStyles({
        widget,
        widgetTheme,
        hasCustomCSS,
        viewAnimation,
        commonUIStyles,
        byCategories,
        elementsHeight,
    });

   // useRecommendations({ widget });

    const appStore = useAppStore();
    
    function nextDisabled () {
        const selected = Object.keys(selectedSchedules);
        if (selected.length > 0) {
            return false;
        }
        return true;
    }

    function getScheduleCount () {
        const selected = Object.keys(selectedSchedules);
        return selected.length;
    }

    function renderByCategories () {
        if (!byCategories) {
            return (<React.Fragment></React.Fragment>);
        }
        return (
            <Grid
                className={classes.categorySpace}
            >
                <Grid className={classNames([classes.categoryUI, 'ecal-category'])}>
                    <Grid className={classNames([classes.categoryLabel, 'ecal-category-label'])}>
                        <span>{translate(TranslationIds.SCHEDULE_CATEGORY_BROWSE)}</span>
                        <span>:</span>
                    </Grid>
                    
                    <Select
                        className={classNames([classes.categorySelect, 'ecal-category-select'])}
                        placeHolder={'Browse Category'}
                        helperText={''}
                        labelHeading={''}
                        value={categoryValue}
                        dataProvider={categories}
                        onChange={(e, value, itemData) => {
                            console.log('onChange() -> ', itemData);
                            selectSchedulesByCategory(itemData);
                        }}
                        name={'category'}
                        
                    />
                </Grid>
            </Grid>
        );
    }

    function getName () {
        if (viewAnimation) {
            return TransitionViewNames.SCHEDULES_VIEW;
        }
        return TransitionViewNames.SCHEDULES_VIEW;
    }

    function animateNextIn () {
        setViewRenderer(TransitionViewRenderers.CALENDARS_VIEW);
        setTransitionsWithTarget({
            direction: TransitionDirection.NEXT,
            animationIn: transitions.slideInFromNext,
            animationOut: transitions.slideOutToBack,
            incomingView: TransitionViewNames.CALENDARS_VIEW,
            outgoingView: TransitionViewNames.SCHEDULES_VIEW,
        });
        appStore.gotoCalendarApps();
    }


    function renderListContent () {
        return (
            <React.Fragment>
                <ScheduleList
                    schedules={schedules}
                    elementsHeight={elementsHeight}
                />

                <Grid className={classNames([classes.actionPanel, 'action-bar', 'ecal-primary-button-container'])}>
                    <PrimaryButton
                        isDisabled={nextDisabled()}
                        onClick={() => {
                            captureFields();
                            appStore.gaChooseSchedule();
                            animateNextIn();
                        }}
                        textLabel={translateWithValues(TranslationIds.SCHEDULE_SYNC_SCHEDULES, { count: getScheduleCount()})}
                    />
                </Grid>
            </React.Fragment>
        );
    }

    function renderTransitionContent () {
        return (
                <WidgetDialog
                    id={TransitionViewNames.SCHEDULES_VIEW}
                    name={getName()}
                    viewAnimation={viewAnimation}
                    isShowBackButton={false}
                    initStyles={initStyles}
                >
                    <Grid className={classes.content}>
                        <Grid className={classNames([classes.headerSpace, 'schedule-header'])}>
                            <TitleHeader
                                widget={widget}
                                widgetTheme={widgetTheme}
                                title={translate(TranslationIds.SCHEDULE_HEADER)}
                                subtitle={translate(TranslationIds.SCHEDULE_HEADING_TEXT)}
                            />
                        </Grid>

                        { renderByCategories() }
                        { renderListContent() }
                    </Grid>
                </WidgetDialog>
           
        );
    }

    if (!appStore.kickstarted) {
        return (<React.Fragment></React.Fragment>);
    }

    return (
        <React.Fragment>
            <ContentContainer
                 viewAnimation={viewAnimation}
            >
                { renderTransitionContent() }   
            </ContentContainer>           
        </React.Fragment>
    );
}

Schedules.propTypes = {
    text: PropTypes.string,
    viewAnimation: PropTypes.bool,
    initStyles: PropTypes.any,
};

export default observer(Schedules);